import { render, staticRenderFns } from "./ExpiredTrial.vue?vue&type=template&id=168aaa96&"
import script from "./ExpiredTrial.vue?vue&type=script&lang=js&"
export * from "./ExpiredTrial.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredTrial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports